import CloseSvg from "@/src/svg/CustomUtils/CloseSvg";
import "./style.scss";

export type NoteData = {
  title: string;
  cost: string;
  date: string;
  description: string;
  img?: React.ComponentType;
};

interface CustomNoteProps {
  note: NoteData[];
  onClose?: () => void;
}

const CustomNote = ({ note, onClose }: CustomNoteProps) => {
  return (
    <div className="custom-note">
      <div className="custom-note-title">
        <div className="custom-note-title-text">
          <p>Note</p>
        </div>
        <div className="custom-note-title-close" onClick={onClose}>
          <CloseSvg />
        </div>
      </div>
      <div className="custom-note-items">
        {note.map((item, index) => (
          <div className="custom-note-items-item" key={index}>
            <div className="custom-note-items-item-row">
              <p>{item.title}</p>
              <span>{item.cost}</span>
            </div>
            <div className="custom-note-items-item-row">
              <p>{item.date}</p>
              {item.img ? <item.img /> : null}
            </div>
            <div className="custom-note-items-item-row">
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomNote;
